import ConstructionSitesDetailedFilters from "@/models/server/ConstructionSitesDetailedFilters";

export default class GetConstructionSitesDetailedFiltersRequest extends ConstructionSitesDetailedFilters {
    
    public pageNumber: number = 1;

    public pageSize: number = 100;
}